module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/gunma-h1-a-febdcd3673f53077afd45af9e184a067.svg";